module.exports = __webpack_public_path__ + "img/20.9dcfe965.png";